import cn from "classnames"
import TextImage from "components/TextMedia/TextImage"
import { RenderBardWithComponents } from "components/Wysiwyg"
import { useState } from "react"
import { DynamicHeadline } from "../DynamicHeadline"
import Section, { parseColors } from "../Section"
import LinkButton from "../ui/LinkButton"
import styles from "./Cta.module.scss"

const Cta = (params) => {
  const { data = {}, colors, content } = params

  const {
    cta_type: type,
    textImageText: text,
    // letter: letterObj,
    link: url,
    link_text: linkText,
    new_tab: newTab,
    // headline_teaser: headlineTeaser,
    dynamic_headline: headline,
    headline_type: headlineType,
    headline_appearance: headlineAppearance,
    ankerslug,
  } = data

  const [ctaHeight, setCtaHeight] = useState(360)

  if (type?.value === "long") return <TextImage {...params} isCta={true} />

  const { accent } = parseColors({ colors })
  const { fontColor } = parseColors({
    colors: [{ name: accent.name, value: accent.color }, {}],
  })

  return (
    <Section
      id={ankerslug}
      sectionSpacing={{
        top: data?.section_padding_top?.value || null,
        bottom: data?.section_padding_bottom?.value || null,
      }}
      className={cn(styles.ctaWrapper, {
        [styles[`ctaWrapper--${content.locale}`]]: content.locale,
      })}
      colors={colors}
      style={{ color: fontColor }}
    >
      <div
        ref={(element) => element && setCtaHeight(element.offsetHeight)}
        className={styles.contentWrapper}
        style={{
          backgroundColor: accent.color,
          ["--cta-height"]: `${ctaHeight}px`,
        }}
      >
        <DynamicHeadline
          headlineType={headlineType.value}
          headlineAppearance={headlineAppearance.value}
          className={styles.headline}
        >
          {headline}
        </DynamicHeadline>
        <div className={styles.text}>
          <RenderBardWithComponents content={text} prefix="text_" />
        </div>
        {url && (
          <LinkButton
            className={cn(styles.button, "button--cta")}
            data={{
              link_url: url,
              link_text: linkText,
              link_blank: newTab,
            }}
          />
        )}
      </div>
    </Section>
  )
}

export default Cta
